<template>
  <div class="columns is-multiline fill-height is-size-7">
    <div class="column is-12">
      <h2 class="is-size-5">
        <div v-if="employer">
          {{ $t('signInToRojgariEmployer') }}
        </div>
        <div v-else>
          {{ $t('signInToRojgari') }}
        </div>
      </h2>
      <p class="has-text-grey is-size-7 is-hidden-mobile">
        {{ $t('siginSubTitle') }}
      </p>
    </div>
    <div class="column is-9">
      <validation-observer ref="observer">
        <validation-provider
          v-slot="{ errors }"
          :name="$t('mobileNumber')"
          :rules="
            employer
              ? 'required|min:7|max:10|integer'
              : 'required|digits:10|integer'
          "
        >
          <div class="field">
            <label class="label is-size-7 has-text-grey">
              <vue-icon-base
                height="16"
                width="16"
                :path="$options.icons[$kc('uni-phone')]"
              >
              </vue-icon-base>
              {{ $t('mobileNumber') }}
              <span class="has-text-danger">*</span>
            </label>

            <div class="columns relative field has-addons mb-0">
              <div
                class="pr-0 pb-0 drop column is-3 is-4-mobile is-4-tablet has-margin-right-10-mobile"
              >
                <flag-field
                  endpoint="/api/v1/common/country"
                  @country="getCountryName"
                ></flag-field>
              </div>

              <div class="column">
                <div class="control">
                  <input
                    v-model="formValues.phone_number"
                    :class="{
                      'is-danger': errors.length || fieldErrors.phone_number
                    }"
                    class="input"
                    type="text"
                    min="0"
                    :placeholder="$t('mobilePlaceholder')"
                    oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                    @keyup.enter="signin"
                  />
                </div>
              </div>
            </div>
            <p class="field-error help is-danger mt-0">
              {{ errors[0] || fieldErrors.phone_number }}
            </p>
          </div>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          :name="$t('password')"
          rules="required"
          vid="password"
        >
          <label class="label is-size-7 has-text-grey">
            <vue-icon-base
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-padlock')]"
            >
            </vue-icon-base>
            {{ $t('password') }}
            <span class="has-text-danger">*</span>
          </label>
          <div class="field has-addons mb-0">
            <div class="control is-expanded">
              <input
                v-model="formValues.password"
                :class="{ 'is-danger': errors.length }"
                class="input"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="$t('password')"
                @keyup.enter="signin"
              />
            </div>
            <div class="control">
              <a class="button" @click="showPassword = !showPassword">
                <vue-icon-base
                  height="20"
                  width="20"
                  :path="
                    $options.icons[
                      $kc(showPassword ? 'uni-eye' : 'uni-eye-slash')
                    ]
                  "
                >
                </vue-icon-base>
              </a>
            </div>
          </div>
          <div class="has-text-grey is-size-7 mt-2">
            <span
              class="pointer is-pulled-right"
              @click="$emit('change', 'forgot-password')"
              v-text="$t('Forgot Password ?')"
            ></span>
          </div>
          <p class="field-error help is-danger">
            {{ errors[0] || fieldErrors.password }}
          </p>
        </validation-provider>
      </validation-observer>

      <button
        :id="!employer ? 'jobSeekerSignInButton' : 'employerSignInButton'"
        :disabled="formValues.password.length <= 0"
        :class="`is-${userColor}`"
        class="button has-text-white my-2"
        @click="signin"
        v-text="$t('signIn')"
      ></button>
    </div>
    <div class="column is-full is-size-7">
      <span v-text="$t('dontHaveAccount')"></span>
      <strong
        :class="`has-text-${userColor}`"
        class="pointer"
        @click="register()"
        v-text="$t('signUp')"
      ></strong>
      <div class="my-2">
        <span
          class="pointer"
          :class="!employer ? 'has-text-employer' : 'has-text-jobseeker'"
          @click="$emit('changeUser', employer ? 'jobseeker' : 'employer')"
          v-text="!employer ? $t('iAmEmployer') : $t('iAmJobseeker')"
        ></span>
      </div>
    </div>
    <!-- <div v-if="!employer" class="is-flex align-center column is-12 is-size-7">
      <div class="mr-2" v-text="$t('signInUsing')"></div>
      <button
        slot="next"
        class="button is-small is-rounded is-info is-text"
        @click="$auth.loginWith('facebook')"
      >
        <vue-icon-base
          height="16"
          width="16"
          fill="blue"
          :path="$options.icons[$kc('uni-facebook-f')]"
        >
        </vue-icon-base>
      </button>
      <button slot="next" class="button is-small is-text">
        <vue-icon-base
          height="16"
          width="16"
          :path="$options.icons[$kc('uni-twitter')]"
          >/
        </vue-icon-base>
      </button>
      <button slot="next" class="button is-small is-text">
        <vue-icon-base
          height="16"
          width="16"
          :path="$options.icons[$kc('uni-google')]"
        >
        </vue-icon-base>
      </button>
    </div> -->
  </div>
</template>

<script>
import FormMixin from '@/mixins/veeValidate'
import VueIconBase from '@/components/Commons/VueIconBase'
import FlagField from '@/components/Commons/FlagField'
import { mapGetters } from 'vuex'
import {
  uniPhone,
  uniPadlock,
  uniEye,
  uniEyeSlash,
  // uniFacebookF,
  // uniTwitter,
  // uniGoogle,
  uniGlobe
} from '@/helpers/icons'

export default {
  icons: {
    uniPhone,
    uniPadlock,
    uniEye,
    uniEyeSlash,
    // uniFacebookF,
    // uniTwitter,
    // uniGoogle,
    uniGlobe
  },
  components: {
    VueIconBase,
    FlagField
  },
  mixins: [FormMixin],
  props: {
    employer: {
      type: Boolean,
      default: false
    },
    extraInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      paymentValue: false,
      purchaseDatapurchaseData: [],
      showPassword: false,
      countryFlag: null,
      formValues: {
        country: '',
        phone_number: '',
        password: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      pricingDetail: 'getPricingData'
    }),
    userColor() {
      return this.employer ? 'employer' : 'jobseeker'
    }
  },
  watch: {
    'formValues.country': {
      handler(val) {
        if (val) {
          const flag = this.convertToSlug(val)
          this.countryFlag = `https://api.rojgari.com/static/country/${flag}.svg`
        }
      }
    }
  },
  methods: {
    async signin() {
      if (this.loading) return
      if (await this.validateAllFields()) {
        this.loading = true
        await this.$auth
          .loginWith('local', { data: this.formValues })
          .then(response => {
            this.handleLogin()
          })
          .catch(error => {
            if (
              error !== undefined &&
              error.response !== undefined &&
              error.response.data !== undefined &&
              error.response.data.non_field_errors !== undefined
            ) {
              const showError = error.response.data.non_field_errors[0]
              this.notifyError(showError)
            } else {
              this.notifyError(this.$t('Something went wrong'))
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    getCountryName(countryName) {
      this.formValues.country = countryName
    },
    handleLogin() {
      if (this.$route.fullPath.includes('/detail')) {
        this.$router.go(0)
      }
      const userType = this.$auth.user.employer_profile
        ? 'employer'
        : 'jobseeker'
      if (
        userType === 'jobseeker' &&
        this.$auth.user.has_preferred_locations === false
      ) {
        this.$emit('close')
        this.$router.push(
          this.localePath({
            name: 'signup-prefered-location'
          })
        )
      } else if (
        userType === 'jobseeker' &&
        this.$auth.user.has_preferred_jobs === false
      ) {
        this.$emit('close')
        this.$router.push(
          this.localePath({
            name: 'signup-prefered-job-category'
          })
        )
      } else if (
        userType === 'jobseeker' &&
        this.$auth.user.has_filled_description_form === false
      ) {
        this.$emit('close')
        this.$router.push(
          this.localePath({
            name: 'signup-basic-information'
          })
        )
      } else if (
        userType === 'jobseeker' &&
        this.$auth.user.has_working_status === false
      ) {
        this.$emit('close')
        this.$router.push(
          this.localePath({
            name: 'signup-working-status'
          })
        )
      } else if (
        userType === 'jobseeker' &&
        this.$auth.user.has_preferred_locations === true &&
        this.$auth.user.has_preferred_jobs === true &&
        this.$auth.user.has_filled_description_form === true &&
        this.$auth.user.has_working_status === true
      ) {
        this.$emit('close')
        this.loginRedirect()
      } else if (userType === 'employer') {
        this.$emit('changeUser', userType)
        this.$emit('change', 'details')
        if (
          this.$auth.user.employer_profile &&
          this.$auth.user.has_filled_initial_form === false
        ) {
          this.$router.push(
            this.localePath({
              name: 'employer-zone'
            })
          )
        } else if (
          this.$auth.user.employer_profile &&
          this.$auth.user.has_filled_initial_form === true &&
          this.extraInfo !== 'pricing'
        ) {
          this.$emit('close')
          this.$router.push(
            this.localePath({
              name: `employer-profile-id`,
              params: { id: 'me' },
              query: { tab: 'active-jobs' }
            })
          )
        } else if (
          this.$auth.user.employer_profile &&
          this.$auth.user.has_filled_initial_form === true &&
          this.extraInfo === 'pricing'
        ) {
          this.purchase()
          this.$emit('close')
          this.$router.push(
            this.localePath({
              name: 'payment-cart-summary'
            })
          )
        }
        if (this.$auth.user.referrer_profile) {
          this.$router.push(
            this.localePath({
              name: 'referrer-profile-id',
              params: { id: 'me' },
              query: { tab: 'my-referees' }
            })
          )
        }
        this.notifyUser(this.$t('Successfully Signed In'))
      }
    },
    async purchase() {
      const endpoint = `api/v1/payment/purchase/`
      const quantity = {
        job_price_setting: this.pricingDetail.id,
        quantity: this.pricingDetail.quantity
      }
      await this.$axios.$post(endpoint, quantity).then(response => {
        this.purchaseData = response
      })
      this.postincart(this.purchaseData)
    },
    async postincart(response) {
      const endpoint = `api/v1/payment/wishlist-item/`
      const postdata = {
        package: response.package || '',
        quantity: response.quantity,
        wished: true
      }
      await this.$axios.$post(endpoint, postdata).then(response => {
        this.$eventBus.$emit('custom-event', (this.paymentValue = true))
        this.$router.push(
          this.localePath({
            name: 'payment-cart-summary'
          })
        )
      })
    },
    register() {
      if (this.employer) {
        this.$emit('close')
        this.$router.push(
          this.localePath({
            name: 'signup-employer'
          })
        )
      } else {
        this.$emit('close')
        this.$router.push(
          this.localePath({
            name: 'signup'
          })
        )
      }
    },
    async loginRedirect() {
      let switchLanguage = { en: 'en', ne: 'ne' }
      if (this.$i18n && this.$i18n.locale === 'ne') {
        switchLanguage = { en: 'ne', ne: 'en' }
      }
      if (this.$auth.user.employer_profile && this.extraInfo !== 'shortlist') {
        this.getShortlistedUserData()
        this.$router.push(
          this.localePath(
            {
              name: `employer-profile-id`,
              params: { id: 'me' },
              query: { tab: 'overview' }
            },
            switchLanguage[this.$i18n.locale]
          )
        )
        this.notifyUser('Successfully Signed In')
      } else if (
        this.$auth.user.jobseeker_profile &&
        this.extraInfo === 'employer-sign-in'
      ) {
        this.$router.push(
          this.localePath({
            name: `jobseeker-profile-id`,
            params: { id: 'me' },
            query: { tab: 'applied-jobs' }
          })
        )
        this.notifyUser('Successfully Signed In')
      } else if (
        this.$auth.user.employer_profile &&
        this.extraInfo === 'shortlist'
      ) {
        await this.$auth.fetchUser()
        this.storeAndUpdateDataInVuex()
        this.$router.push(
          this.localePath(
            {
              name: 'employer-profile-id',
              params: { id: 'me' },
              query: { tab: 'shortlisted-jobseeker' }
            },
            switchLanguage[this.$i18n.locale]
          )
        )
        this.notifyUser('Successfully Signed In')
      } else if (
        this.$auth.user.jobseeker_profile &&
        this.extraInfo !== 'shortlist' &&
        this.extraInfo === 'job-detail'
      ) {
        this.$store.dispatch('shoppingCart/resetEmployerJobSeekerShortlist')
        this.$router.push(
          this.localePath({
            name: 'job-jobSlug-detail',
            params: { jobSlug: this.extraInfo }
          })
        )
        this.notifyUser(this.$t('Successfully Signed In'))
      } else {
        this.$store.dispatch('shoppingCart/resetEmployerJobSeekerShortlist')
        this.$router.push(
          this.localePath({
            name: `jobseeker-profile-id`,
            params: { id: 'me' },
            query: { tab: 'applied-jobs' }
          })
        )
        this.notifyUser(this.$t('Successfully Signed In'))
      }
    },
    getShortlistedUserData() {
      this.$axios
        .get('/api/v1/payment/hiring-package/jobseekers')
        .then(response => {
          const storeData = response.data.hiring_package
            ? response.data.hiring_package.map(x => x.jobseeker)
            : []
          this.$store.dispatch('shoppingCart/syncFromStore', storeData)
        })
    },
    storeAndUpdateDataInVuex() {
      this.$axios
        .post('/api/v1/payment/hiring-package/', {
          jobseekers: this.$store.getters[
            'shoppingCart/shortlistedJobseekerUsernames'
          ]
        })
        .then(() => {
          this.getShortlistedUserData()
          this.$store.dispatch('shoppingCart/triggerAlertMessage', true)
        })
    },
    convertToSlug(Text) {
      if (Text) {
        return Text.toLowerCase()
          .replace(/ /g, '-')
          .replace(/[^\w-]+/g, '')
      }
    }
  }
}
</script>

<style scoped>
.relative {
  position: relative;
}
.drop {
  position: unset;
}
</style>
